import { useEnhanceReducer } from 'customHooks/enhanceReducer';
import Dexie from 'dexie';

const db = new Dexie('annotation');
const readerToolSettingsDB = new Dexie('readerToolSettings');

db.version(1).stores({
    annotation: '&id, bookId, type, isDirty',
});

readerToolSettingsDB.version(1).stores({
    readerToolSettings: '&id'
});

const initState = {
    db,
    readerToolSettingsDB
};

const DBReducer = (state, action) => {
    return state;
};

const useDBReducer = () => useEnhanceReducer(DBReducer, initState);

export default useDBReducer;
